import React, { useEffect, useRef, useState } from 'react';
import { Modal as BsModal } from 'react-bootstrap';
import PlatformIcon from './PlatformIcon';

const LOSSES = [
  'усі збережені кліки цього додатка',
  'налаштування трафіку, фільтрів і клоакінгу',
  'виданий click token',
];

export default function DeleteAppModal({ show, app, platform, onCancel, onConfirm }) {
  const [value, setValue] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const inputRef = useRef(null);

  const appId = String(app?.appId ?? '').trim();
  const matched = appId !== '' && value.trim() === appId;

  useEffect(() => {
    if (!show) return;
    setValue('');
    setBusy(false);
    setError('');
  }, [show, appId]);

  const submit = async (event) => {
    event.preventDefault();
    if (!matched || busy) return;

    setBusy(true);
    setError('');

    try {
      await onConfirm(app);
    } catch (err) {
      setBusy(false);
      setError(err?.message || 'Не вдалося видалити додаток');
      inputRef.current?.focus();
    }
  };

  const close = () => {
    if (busy) return;
    onCancel();
  };

  return (
    <BsModal
      show={show}
      onHide={close}
      centered
      backdrop={busy ? 'static' : true}
      keyboard={!busy}
      dialogClassName="dm-modal"
      onEntered={() => inputRef.current?.focus()}
    >
      <form onSubmit={submit}>
        <BsModal.Header closeButton={!busy}>
          <BsModal.Title className="dm-title">
            <span className="dm-mark" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none">
                <path
                  d="M12 8.5v5M12 17h.01"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                />
                <path
                  d="M10.3 3.9 2.5 17.5a2 2 0 0 0 1.7 3h15.6a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            Видалити додаток
          </BsModal.Title>
        </BsModal.Header>

        <BsModal.Body className="dm-body">
          <div className="dm-target">
            <PlatformIcon platform={platform} size={18} className="dm-target-icon" />
            <div className="dm-target-main">
              <div className="dm-target-id">{appId || '—'}</div>
              <div className="dm-target-url" title={app?.appUrl || ''}>
                {app?.appUrl || 'без URL'}
              </div>
            </div>
          </div>

          <div className="dm-warn">
            <div className="dm-warn-title">Разом із додатком назавжди зникнуть</div>
            <ul className="dm-warn-list">
              {LOSSES.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <div className="dm-warn-note">
              Нові кліки на цей App ID оброблятись не будуть. Дію не можна скасувати.
            </div>
          </div>

          <div className="dm-confirm">
            <label className="dm-label" htmlFor="dm-input">
              Для підтвердження введіть <span className="dm-code">{appId}</span>
            </label>
            <input
              id="dm-input"
              ref={inputRef}
              className="f-input dm-input"
              value={value}
              onChange={(event) => setValue(event.target.value)}
              placeholder="App ID"
              autoComplete="off"
              autoCorrect="off"
              spellCheck="false"
              disabled={busy}
            />
          </div>

          {error ? <div className="dm-error">{error}</div> : null}
        </BsModal.Body>

        <BsModal.Footer className="dm-footer">
          <button type="button" className="fbtn" onClick={close} disabled={busy}>
            Скасувати
          </button>
          <button type="submit" className="fbtn is-danger-solid" disabled={!matched || busy}>
            {busy ? 'Видалення…' : 'Видалити назавжди'}
          </button>
        </BsModal.Footer>
      </form>
    </BsModal>
  );
}
